import { BorderGridContainer, GridBox, H2, P, theme } from '@ahmdigital/ui';
import { capitalize, isEmpty, map } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import BenefitItem, { BenefitItemType } from './benefit-item';
import uncapFpIterator from '../../../../utils/uncap-fp-iterator';

type Props = {
  content: {
    benefits: BenefitItemType[];
    slogan?: string;
  } | null;
  insuranceType?: string;
};

const { media, mediaQueries } = theme;

const ContentWrapper = styled.div`
  ${mediaQueries.above(media.lg)} {
    padding: 2.5rem 6.5rem;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  text-align: center;
`;

const CoreBenefitsSection = ({ content, insuranceType }: Props) => {
  if (isEmpty(content)) {
    return null;
  }

  const { benefits, slogan } = content;

  return (
    <BorderGridContainer>
      <GridBox>
        <ContentWrapper>
          {(insuranceType || slogan) && (
            <TitleWrapper>
              {insuranceType && <H2>{`Benefits of our ${capitalize(insuranceType)} insurance`}</H2>}
              {slogan && <P>{slogan}</P>}
            </TitleWrapper>
          )}

          {uncapFpIterator(map)((benefit: BenefitItemType, index: number) => {
            const isEven = index % 2 === 1;

            return <BenefitItem {...benefit} isReverse={isEven} />;
          }, benefits)}
        </ContentWrapper>
      </GridBox>
    </BorderGridContainer>
  );
};

export default CoreBenefitsSection;
